import { useI18n } from "@/context/I18nContext";
import { Pill, fmtDateTime } from "@/components/hub/Common";

export const TicketList = ({ list, active, onPick, admin = false }) => {
  const { t } = useI18n();
  if (!list.length) return <p className="text-sm text-slate-500" data-testid="tickets-empty">{t("sup.empty")}</p>;
  return (
    <div className="space-y-2" data-testid="tickets-list">
      {list.map((tk) => {
        const unread = admin ? tk.unread_admin : tk.unread_user;
        return (
          <button key={tk.id} data-testid={`ticket-item-${tk.id}`} onClick={() => onPick(tk.id)}
            className={`w-full text-left rounded-xl border px-4 py-3 transition-colors duration-200 ${active === tk.id ? "border-[#2f7bff]/60 bg-[#2f7bff]/10" : "border-white/5 bg-white/[0.02] hover:border-white/15"}`}>
            <div className="flex items-center gap-2">
              {unread && <span className="w-2 h-2 rounded-full bg-[#3ad7ff] shadow-[0_0_8px_#3ad7ff]" data-testid={`ticket-unread-${tk.id}`} title={t("sup.new_reply")} />}
              <span className="font-medium text-sm text-white truncate flex-1">{tk.subject}</span>
              <Pill tone={tk.status}>{t(`sup.st_${tk.status}`)}</Pill>
            </div>
            <div className="text-xs text-slate-500 mt-1 truncate">{admin ? `${tk.user_name} · ${tk.tenant_id} · ` : ""}{t(`sup.cat_${tk.category}`)} · {fmtDateTime(tk.updated_at)}</div>
          </button>
        );
      })}
    </div>
  );
};
